import {action, makeObservable, observable} from "mobx";
import {Ioc} from "../models/ioc";
import {requests} from "../api";

declare var defaultToken: any

export default class LogsStore {
    @observable file?: File
    @observable code = ""
    @observable data?: Ioc[]
    @observable totalFound = 0
    @observable uniqueFound = 0
    @observable truncated = 0

    constructor() {
        makeObservable(this)
        let code
        if (!code) {
            try {
                code = localStorage.getItem('auth_code')!
            } catch (e) {}
        }
        this.code = defaultToken || code
    }

    @action
    setCode = (code: string) => {
        this.code = code
    }

    @action
    setFile = (file: File) => {
        this.file = file
    }

    @action
    loadData = () => {
        return requests.post('/user/check_log', this.file!, {Authorization: this.code})
            .then(d => {
                this.data = d.matches.data._data.map((v:any) => new Ioc(v))
                this.totalFound = d.total
                this.uniqueFound = d.unique
                this.truncated = d.truncated ? d.truncatedLength : 0
                return
            })
    }
}